// Generated types for EntityMatchTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface EntityMatchTaskReadAPI extends LLMTaskReadAPI {
}

export interface EntityMatchTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const EntityMatchTaskReadAPISchemaObject = LLMTaskReadAPISchemaObject.extend({}).passthrough();
export const EntityMatchTaskReadAPISchema: z.ZodType<EntityMatchTaskReadAPI> = EntityMatchTaskReadAPISchemaObject;

export const EntityMatchTaskWriteAPISchemaObject = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
export const EntityMatchTaskWriteAPISchema: z.ZodType<EntityMatchTaskWriteAPI> = EntityMatchTaskWriteAPISchemaObject;
